import { useEffect, useContext, useMemo } from "react";
import SurfacesBox from "../SurfacesBox/SurfacesBox";
import { Accordion, AccordionTab } from "primereact/accordion";
import Checkboxes from "../../components/CheckBox/Checkboxes";
import Checkbox from "../../components/CheckBox/Checkbox";
import Input from "../../components/Input/Input";
import Textarea from "../../components/Textarea/Textarea";
import InputsGroup from "../../components/InputsGroup/InputsGroup";
import Multicheckbox from "../../components/CheckBox/Multicheckbox";
import { Select, MultiSelect } from "./../index";
import {
  organizeZonesByGroup,
  organizeCostaZones,
  PATRIMONIAL_GROUPS,
  RESIDENTIAL_GROUPS,
  getAvailableBuildingTypes,
  RUSTIC_SINGULAR_GROUPS,
} from "../../functions/ads/ad-functions";
import {
  departmentOptions,
  ARRAY_FIELDS,
  BOOLEAN_FIELDS,
  costaGroups,
  departmentFields,
  FIELDS_TO_RESET,
  patrimonioGroups,
  residentialGroups,
  singularesYRusticoGroups,
} from "../../constants/ads-requests-constants";
import { UserContext } from "../Context/AuthUser";
import "./DetailsAds.scss";
import { QualityItem } from "./QualityItem";
import {
  checkIfIncludes,
  formatCurrency,
  validateZone,
} from "../../utils/formatters";
import { qualityIcons } from "../../constants/qualityIcons";
import { getPriceInputs, getSurfaceInputs } from "./DetailsAdsInputsObjects";

const DetailsAds = ({
  formProps,
  id,
  owners,
  owner,
  consultants,
  consultant,
  setOwner,
  setConsultant,
  residentials,
  patrimonials,
  others,
  costa,
  rusticAndSingular,
  setResidentialZones,
  setPatrimonialZones,
  othersSelectedZones,
  setOthersZones,
  costaSelectedZones,
  setCostaZones,
  rusticAndSingularSelectedZones,
  setRusticAndSingularSelectedZones,
  buildingType,
  setBuildingType,
  selectedRealStatePortals,
  setSelectedRealStatePortals,
  adType,
  setAdType,
  department,
  setDepartment,
  adStatus,
  adShowOnWeb,
  adOffMarket,
  setAdOffMarket,
  setAdShowOnWeb,
  updateSufracesBox,
  setUpdateSufracesBox,
}) => {
  const { user } = useContext(UserContext);

  const newSelect = (selected, setSelected, ev) => {
    if (selected.includes(ev.target.value)) {
      const newSelected = selected.filter(
        (selected) => selected !== ev.target.value,
      );
      setSelected(newSelected);
    } else {
      setSelected([...selected, ev.target.value]);
    }
  };

  const zone = formProps.values.department;

  useEffect(() => {
    if (
      zone !== "Patrimonio" &&
      zone !== "Residencial" &&
      zone !== "Otros" &&
      zone !== "Costa" &&
      zone !== "Campos Rústicos & Activos Singulares"
    ) {
      setBuildingType([]);
    }
  }, [zone, setBuildingType]);

  const organizedPatrimonials = useMemo(
    () => organizeZonesByGroup(patrimonials, PATRIMONIAL_GROUPS),
    [patrimonials],
  );

  const organizedResidentials = useMemo(
    () => organizeZonesByGroup(residentials, RESIDENTIAL_GROUPS),
    [residentials],
  );

  const organizedCosta = useMemo(() => organizeCostaZones(costa), [costa]);

  const organizedRusticAndSingulars = useMemo(
    () => organizeZonesByGroup(rusticAndSingular, RUSTIC_SINGULAR_GROUPS),
    [rusticAndSingular],
  );

  const surfaceInputs = getSurfaceInputs(formProps, zone);
  const allPriceInputs = getPriceInputs(formProps);

  // Dividimos el array: los primeros 4 son de Venta, los últimos 4 son de Alquiler
  const saleInputs = allPriceInputs.slice(0, 4);
  const rentInputs = allPriceInputs.slice(4, 8);

  const handleDepartmentChange = (newDept) => {
    // 1. Actualización de estados locales de una sola vez
    setDepartment(newDept);
    setBuildingType([]);
    setResidentialZones([]);
    setPatrimonialZones([]);
    setOthersZones([]);
    setCostaZones([]);
    setRusticAndSingularSelectedZones([]);

    // 2. Creación de un objeto de valores reseteados
    // En lugar de hacer 80 setFieldValues (que disparan 80 re-renders),
    // calculamos el nuevo estado del formulario y lo aplicamos de golpe.
    const resetValues = {};

    FIELDS_TO_RESET.forEach((field) => {
      if (BOOLEAN_FIELDS.includes(field)) {
        resetValues[field] = false;
      } else if (ARRAY_FIELDS.includes(field)) {
        resetValues[field] = [];
      } else if (
        field.endsWith("Value") ||
        [
          "monthlyRent",
          "expenses",
          "bedrooms",
          "bathrooms",
          "parking",
          "jobPositions",
          "indoorPool",
          "outdoorPool",
        ].includes(field)
      ) {
        resetValues[field] = 0;
      } else {
        resetValues[field] = "";
      }
    });

    // Forzamos el nuevo departamento en el objeto de reseteo
    resetValues.department = newDept;

    // 3. Actualización Masiva (Atomic Update)
    // setValues es mucho más rápido que setFieldValue en bucle
    formProps.setValues({
      ...formProps.values,
      ...resetValues,
    });
  };

  return (
    <>
      <div className="DetailsAds__container">
        <div
          className="DetailsAds__container__col"
          style={{ marginBottom: "2rem" }}
        >
          <div className="DetailsAds__container__col__web__button">
            <Multicheckbox
              label="Opciones de publicación"
              onChange={() => {}}
              inputs={[
                {
                  value: "Mostrar en la Web - Total",
                  checked: adShowOnWeb,
                  onChange: (ev) => {
                    const isChecked = ev.target.checked;
                    // 1. Actualizamos el estado actual
                    setAdShowOnWeb(isChecked);
                    formProps.setFieldValue("showOnWeb", isChecked);

                    // 2. Si activamos este, forzamos el apagado del otro
                    if (isChecked) {
                      setAdOffMarket(false);
                      formProps.setFieldValue("showOnWebOffMarket", false);
                    }
                  },
                },
                {
                  value: "Mostrar en la Web - OFF Market",
                  checked: adOffMarket,
                  onChange: (ev) => {
                    const isChecked = ev.target.checked;
                    // 1. Actualizamos el estado actual
                    setAdOffMarket(isChecked);
                    formProps.setFieldValue("showOnWebOffMarket", isChecked);

                    // 2. Si activamos este, forzamos el apagado del otro
                    if (isChecked) {
                      setAdShowOnWeb(false);
                      formProps.setFieldValue("showOnWeb", false);
                    }
                  },
                },
              ]}
            />

            <Multicheckbox
              label="Portales inmobiliarios"
              onChange={(ev) =>
                newSelect(
                  selectedRealStatePortals,
                  setSelectedRealStatePortals,
                  ev,
                )
              }
              inputs={[
                {
                  value: "Idealista",
                  checked: selectedRealStatePortals.includes("Idealista")
                    ? true
                    : "",
                  onChange: (ev) =>
                    newSelect(
                      selectedRealStatePortals,
                      setSelectedRealStatePortals,
                      ev,
                    ),
                },
                {
                  value: "Otros portales",
                  checked: selectedRealStatePortals.includes("Otros portales")
                    ? true
                    : "",
                  onChange: (ev) =>
                    newSelect(
                      selectedRealStatePortals,
                      setSelectedRealStatePortals,
                      ev,
                    ),
                },
              ]}
            />
            {/* {size < 478 ? (
              <>
                <a
                  href={`https://gvre.es/${departmentUrl(
                    zone,
                    othersSelectedZones,
                  )}/${id}`}
                  target="blank"
                  className="buttonGoWeb"
                >
                  <WebImage
                    className="navigate__link--icon"
                    style={{ width: "2em", height: "2em" }}
                  />
                  Ir a web
                </a>
              </>
            ) : null} */}
          </div>
          <div>
            <Input
              value={formProps.values.title}
              label="Título del anuncio"
              name="title"
              placeholder="Escribe aquí"
              required="required"
              onChange={(ev) =>
                formProps.setFieldValue(ev.target.name, ev.target.value)
              }
            />
          </div>
          <div className="DetailsAds__container__col__featured__checks">
            <Checkbox
              label="Destacado Web"
              name="featuredOnMain"
              checked={formProps.values.featuredOnMain}
              onChange={(ev) => {
                formProps.setFieldValue(
                  ev.target.name,
                  !formProps.values.featuredOnMain,
                );
              }}
            />
            <Checkbox
              label="Planos destacados"
              name="featuredDrawings"
              checked={formProps.values.featuredDrawings}
              onChange={(ev) => {
                formProps.setFieldValue(
                  ev.target.name,
                  !formProps.values.featuredDrawings,
                );
              }}
            />
          </div>

          <div style={{ display: "flex" }}>
            <InputsGroup
              label="Dirección"
              inputs={[
                {
                  name: "street",
                  label: "Calle",
                  value: formProps.values.street,
                  onChange: (ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value),
                  required: true,
                  style: "direction",
                  errors: "",
                },
                {
                  name: "directionNumber",
                  type: "text",
                  label: "Número",
                  value: formProps.values.directionNumber,
                  onChange: (ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value),
                  required: true,
                  style: "direction",
                  errors: "",
                },
                {
                  name: "directionFloor",
                  label: "Piso",
                  value: formProps.values.directionFloor,
                  onChange: (ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value),
                  style: "direction",
                  errors: "",
                },
                {
                  name: "postalCode",
                  label: "Código postal",
                  value: formProps.values.postalCode,
                  onChange: (ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value),
                  style: "direction",
                  errors: "",
                },
                {
                  name: "city",
                  label: "Ciudad",
                  value: formProps.values.city,
                  onChange: (ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value),
                  style: "direction",
                  errors: "",
                },
                {
                  name: "country",
                  label: "País",
                  value: formProps.values.country,
                  onChange: (ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value),
                  style: "direction",
                  errors: "",
                },
              ]}
              directionStyle="direction"
            />
          </div>
          <div className="DetailsAds__container">
            <div className="DetailsAds__container__col">
              <Checkboxes
                label="Tipo de anuncio"
                textA="Alquiler"
                valueA="Alquiler"
                onChangeA={(ev) => newSelect(adType, setAdType, ev)}
                checkedA={adType.includes("Alquiler") ? true : ""}
                textB="Venta"
                valueB="Venta"
                onChangeB={(ev) => newSelect(adType, setAdType, ev)}
                checkedB={adType.includes("Venta") ? true : ""}
              />
            </div>
            <div className="DetailsAds__container__col">
              <Checkboxes
                label="Cierre operación GV"
                type="radio"
                textA="Alquilado"
                valueA="Alquilado"
                onChangeA={(ev) => {
                  formProps.setFieldValue("gvOperationClose", ev.target.value);
                }}
                checkedA={
                  formProps.values.gvOperationClose === "Alquilado" ? true : ""
                }
                textB="Vendido"
                valueB="Vendido"
                onChangeB={(ev) => {
                  formProps.setFieldValue("gvOperationClose", ev.target.value);
                }}
                checkedB={
                  formProps.values.gvOperationClose === "Vendido" ? true : ""
                }
                textC="Ninguno"
                valueC=""
                onChangeC={(ev) => {
                  formProps.setFieldValue("gvOperationClose", ev.target.value);
                }}
                checkedC={formProps.values.gvOperationClose === "" ? true : ""}
              />
            </div>
          </div>

          <Select
            label="Departamento"
            list={departmentOptions}
            fields={{ groupBy: "", text: "name", value: "name" }}
            filter={(e) => {
              const searchData = departmentOptions.filter((dept) =>
                checkIfIncludes(dept.name, e.text),
              );
              e.updateData(searchData);
            }}
            fn={(e) => handleDepartmentChange(e.value)}
            defaultValues={formProps.values.department || null}
            defaultName={
              !formProps.values.department ? "Selecciona un Departamento" : ""
            }
          />
        </div>
        <div className="DetailsAds__container__col">
          <div>
            <Select
              label="Propietario"
              list={owners?.sort((a, b) => {
                if (a.createdAt < b.createdAt) {
                  return 1;
                } else return -1;
              })}
              fields={{ groupBy: "", text: "fullName", value: "_id" }}
              filter={(e) => {
                const searchData = owners.filter((owner) => {
                  if (
                    checkIfIncludes(owner.fullName, e.text) ||
                    checkIfIncludes(owner.email, e.text) ||
                    checkIfIncludes(owner.company, e.text) ||
                    checkIfIncludes(owner.contactMobileNumber, e.text)
                  )
                    return owner;
                });
                if (searchData.length !== 0) e.updateData(searchData);
                else e.updateData([]);
              }}
              fn={(ev) => {
                setOwner(ev.target.value);
              }}
              defaultValues={owner ? owner : ""}
            />
          </div>
          <div>
            <Select
              label="Consultor"
              list={consultants.sort((a, b) => {
                if (a.fullName.toLowerCase() < b.fullName.toLowerCase())
                  return -1;
                else return 1;
              })}
              filter={(e) => {
                const searchData = consultants.filter((consultant) => {
                  if (
                    checkIfIncludes(consultant.fullName, e.text) ||
                    checkIfIncludes(consultant.consultantEmail, e.text) ||
                    checkIfIncludes(consultant.consultantMobileNumber, e.text)
                  )
                    return consultant;
                });
                if (searchData.length !== 0) e.updateData(searchData);
                else e.updateData([]);
              }}
              fields={{ text: "fullName", value: "_id" }}
              fn={(ev) => {
                setConsultant(ev.target.value);
              }}
              defaultValues={consultant ? consultant : ""}
              defaultName={user ? user.fullName : ""}
            />
          </div>
          <div>
            <Input
              required="required"
              label="Referencia del anuncio"
              name="adReference"
              value={formProps.values.adReference}
              onChange={(ev) =>
                formProps.setFieldValue(ev.target.name, ev.target.value.trim())
              }
            />
          </div>
          <div>
            {/* {poner un text area con un label de comentarios internos} */}
            <Textarea
              name="internalComments"
              label="Comentarios internos"
              placeholder="Escribe aquí"
              value={formProps.values.internalComments}
              onChange={(ev) =>
                formProps.setFieldValue(ev.target.name, ev.target.value)
              }
            />
          </div>
        </div>
      </div>
      {formProps.values.department && (
        <Accordion multiple>
          <AccordionTab header="Información básica">
            <div className="DetailsAds__container">
              <div className="DetailsAds__container__col">
                <div>
                  <Multicheckbox
                    label="Tipo de inmueble"
                    required={buildingType.length === 0 ? true : false}
                    onChange={(ev) =>
                      newSelect(buildingType, setBuildingType, ev)
                    }
                    inputs={getAvailableBuildingTypes(zone).map((item) => ({
                      value: item.value,
                      label: item.label,
                      checked: buildingType.includes(item.value),
                      onChange: (ev) =>
                        newSelect(buildingType, setBuildingType, ev),
                    }))}
                  />
                </div>

                <div>
                  {zone === "Residencial" && (
                    <MultiSelect
                      label="Zonas de Residencial"
                      list={organizedResidentials}
                      mode={"Checkbox"}
                      fields={{ groupBy: "zone", text: "name", value: "_id" }}
                      onChange={(ev) => {
                        setResidentialZones(ev.value);
                        formProps.setFieldValue("zone", ev.value);
                      }}
                      value={
                        validateZone(residentials, formProps)
                          ? formProps.values.zone.map((z) =>
                              typeof z === "object" ? z._id : z,
                            )
                          : []
                      }
                    />
                  )}
                  {zone === "Patrimonio" && (
                    <MultiSelect
                      label="Zonas de Patrimonio"
                      list={organizedPatrimonials}
                      mode={"Checkbox"}
                      fields={{ groupBy: "zone", text: "name", value: "_id" }}
                      onChange={(ev) => {
                        setPatrimonialZones(ev.value);
                        formProps.setFieldValue("zone", ev.value);
                      }}
                      value={
                        validateZone(patrimonials, formProps)
                          ? formProps.values.zone.map((z) =>
                              typeof z === "object" ? z._id : z,
                            )
                          : []
                      }
                    />
                  )}
                  {zone === "Costa" && (
                    <MultiSelect
                      label="Zonas de Costa"
                      list={organizedCosta}
                      mode={"Checkbox"}
                      fields={{
                        groupBy: "zone",
                        text: "name",
                        value: "_id",
                      }}
                      onChange={(ev) => {
                        setCostaZones(ev.value);
                        formProps.setFieldValue("zone", ev.value);
                      }}
                      value={
                        validateZone(costa, formProps)
                          ? formProps.values.zone.map((z) =>
                              typeof z === "object" ? z._id : z,
                            )
                          : []
                      }
                    />
                  )}

                  {zone === "Campos Rústicos & Activos Singulares" && (
                    <MultiSelect
                      label={"Zones de Campos Rústicos & Activos Singulares"}
                      list={organizedRusticAndSingulars}
                      mode={"Checkbox"}
                      fields={{
                        groupBy: "zone",
                        text: "name",
                        value: "_id",
                      }}
                      onChange={(ev) => {
                        setRusticAndSingularSelectedZones(ev.value);
                        formProps.setFieldValue("zone", ev.value);
                      }}
                      value={
                        validateZone(rusticAndSingular, formProps)
                          ? formProps.values.zone.map((z) =>
                              typeof z === "object" ? z._id : z,
                            )
                          : []
                      }
                    />
                  )}
                </div>
                <div>
                  <Textarea
                    label="Subtítulo Web"
                    type="text"
                    name="webSubtitle"
                    placeholder="Escribe aquí"
                    value={formProps.values.webSubtitle}
                    onChange={(ev) =>
                      formProps.setFieldValue(ev.target.name, ev.target.value)
                    }
                  />
                </div>

                {formProps.values.department === "Patrimonio" && (
                  <>
                    <Input
                      label="Planta"
                      type="text"
                      placeholder="Escribe aquí"
                      name="floor"
                      value={formProps.values.floor}
                      onChange={(ev) =>
                        formProps.setFieldValue(ev.target.name, ev.target.value)
                      }
                    />

                    <Input
                      label="Disponibilidad"
                      type="text"
                      placeholder="Escribe aquí"
                      name="disponibility"
                      value={formProps.values.disponibility}
                      onChange={(ev) =>
                        formProps.setFieldValue(ev.target.name, ev.target.value)
                      }
                    />

                    <br />
                    <SurfacesBox
                      formProps={formProps}
                      updateSufracesBox={updateSufracesBox}
                      setUpdateSufracesBox={setUpdateSufracesBox}
                    />
                  </>
                )}
              </div>
              <div className="DetailsAds__container__col">
                <div className="DetailsAds__container__col--item">
                  <InputsGroup label="Superficie" inputs={surfaceInputs} />
                </div>
                <div className="DetailsAds__prices-grid">
                  <div className="DetailsAds__prices-grid__col">
                    <InputsGroup label="Precio de Venta" inputs={saleInputs} />
                  </div>
                  <div className="DetailsAds__prices-grid__col">
                    <InputsGroup
                      label="Precio de Alquiler"
                      inputs={rentInputs}
                    />
                  </div>
                </div>

                {formProps.values.department === "Patrimonio" && (
                  <div className="DetailsAds__container__col--item">
                    <InputsGroup
                      label="Alquiler Patrimonio"
                      inputs={[
                        {
                          name: "monthlyRent",
                          label: "Renta mensual",
                          type: "number",
                          placeholder: "Escribe aquí",
                          value: formProps.values.monthlyRent,
                          lang: "es-ES",
                          step: "0.01",
                          onChange: (ev) => {
                            formProps.setFieldValue(
                              ev.target.name,
                              ev.target.value,
                            );
                            formProps.setFieldValue(
                              "rentValue",
                              Math.round(
                                ev.target.value * formProps.values.buildSurface,
                              ),
                            );
                            formProps.setFieldValue(
                              "expensesIncluded",
                              Math.round(
                                ev.target.value * formProps.values.buildSurface +
                                  formProps.values.expenses *
                                    formProps.values.buildSurface,
                              ),
                            );
                          },
                          span: (
                            <span
                              style={{
                                position: "absolute",
                                right: "0.5%",
                                top: "52%",
                              }}
                            >
                              €/m<sup>2</sup>/mes
                            </span>
                          ),
                          errors: "",
                        },
                        {
                          name: "expenses",
                          label: "Gastos",
                          type: "number",
                          value: formProps.values.expenses,
                          placeholder: "Escribe aquí",
                          lang: "es-ES",
                          step: "0.01",
                          onChange: (ev) => {
                            formProps.setFieldValue(
                              ev.target.name,
                              ev.target.value,
                            );
                            formProps.setFieldValue(
                              "expensesIncluded",
                              Math.round(
                                formProps.values.monthlyRent *
                                  formProps.values.buildSurface +
                                  formProps.values.buildSurface * ev.target.value,
                              ),
                            );
                          },
                          span: (
                            <span
                              style={{
                                position: "absolute",
                                right: "0.5%",
                                top: "52%",
                              }}
                            >
                              €/m<sup>2</sup>/mes
                            </span>
                          ),
                          errors: "",
                        },
                        {
                          name: "expensesIncluded",
                          label: "Alquiler con gastos incluidos",
                          type: "text",
                          value:
                            formProps.values.expensesIncluded !== ""
                              ? formatCurrency(
                                  Math.round(
                                    formProps.values.buildSurface *
                                      formProps.values.monthlyRent +
                                      formProps.values.buildSurface *
                                        formProps.values.expenses,
                                  ),
                                )
                              : "",
                          lang: "es-ES",
                          step: "0.01",
                          onChange: (ev) => {
                            formProps.setFieldValue(
                              "expensesIncluded",
                              Math.round(
                                formProps.values.monthlyRent *
                                  formProps.values.buildSurface +
                                  formProps.values.buildSurface * ev.target.value,
                              ),
                            );
                          },
                          required: false,
                          span: (
                            <span
                              style={{
                                position: "absolute",
                                right: "0.5%",
                                top: "52%",
                              }}
                            >
                              €/mes
                            </span>
                          ),
                          errors: "",
                        },
                      ]}
                    />
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    gap: "4rem",
                    margin: "20px 0px",
                  }}
                >
                  {/* 1. EL CHECKBOX */}
                  {zone === "Patrimonio" && (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          display: "block",
                          fontSize: "14px",
                          marginBottom: "15px",
                          fontWeight: "700",
                          textAlign: "left",
                        }}
                      >
                        En Rentabilidad
                      </span>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingLeft: "8px",
                          borderLeft: "2px solid #2B363D",
                          height: "18px",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            gap: "5px",
                          }}
                        >
                          <input
                            id="profitability"
                            type="checkbox"
                            name="profitability"
                            style={{ margin: 0 }}
                            checked={formProps.values.profitability} // Para checkboxes es mejor usar 'checked' que 'value'
                            value={formProps.values.profitability} // Depende de cómo esté hecho tu componente Input
                            onChange={() => {
                              const newValue = !formProps.values.profitability;
                              formProps.setFieldValue(
                                "profitability",
                                newValue,
                              );

                              // UX: Si el usuario desmarca el check, reiniciamos el valor a 0
                              if (!newValue) {
                                formProps.setFieldValue(
                                  "profitabilityValue",
                                  null,
                                );
                              }
                            }}
                          />
                          <span htmlFor="profitability">Rentabilidad</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* 2. EL INPUT NUMÉRICO (Solo se muestra si profitability es true) */}
                  {formProps.values.profitability && (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          display: "block",
                          fontSize: "14px",
                          marginBottom: "15px",
                          fontWeight: "700",
                          textAlign: "left",
                        }}
                      >
                        Valor (%)
                      </span>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "18px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                          }}
                        >
                          <div style={{ position: "relative" }}>
                            <input
                              id="profitabilityValue"
                              style={{
                                backgroundColor: "#fff",
                                border: "none",
                                outline: "none",
                                borderBottom: "1px solid #b0b0b0",
                                width: "100%",
                                paddingLeft: "5px",
                                paddingRight: "5px",
                              }}
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              name="profitabilityValue"
                              placeholder="Escribe aquí"
                              step="0.01" // Permite escribir decimales
                              value={formProps.values.profitabilityValue}
                              onChange={(ev) =>
                                formProps.setFieldValue(
                                  "profitabilityValue",
                                  ev.target.value,
                                )
                              }
                            />

                            <span
                              style={{
                                position: "absolute",
                                right: "5%",
                                top: "10%",
                              }}
                            >
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="DetailsAds__container__col--item">
                  <InputsGroup
                    label="Gastos de comunidad"
                    inputs={[
                      {
                        name: "expensesValue",
                        label: "",
                        type: "number",
                        value: formProps.values.expensesValue,
                        step: "0.01",
                        onChange: (e) =>
                          formProps.setFieldValue(
                            "expensesValue",
                            e.target.value,
                          ),
                        span: (
                          <span
                            style={{
                              position: "absolute",
                              right: "0.5%",
                              top: "10%",
                            }}
                          >
                            €/mes
                          </span>
                        ),
                        errors: "",
                      },
                      {
                        name: "expensesShowOnWeb",
                        label: "Mostrar Web",
                        type: "checkbox",
                        checked: formProps.values.expensesShowOnWeb,
                        onChange: (ev) =>
                          formProps.setFieldValue(
                            ev.target.name,
                            !formProps.values.expensesShowOnWeb,
                          ),
                        errors: "",
                      },
                    ]}
                  />
                </div>
                <div className="DetailsAds__container__col--item">
                  <InputsGroup
                    label="IBI"
                    inputs={[
                      {
                        name: "ibiValue",
                        label: "",
                        type: "number",
                        placeholder: "Escribe aquí",
                        value: formProps.values.ibiValue,
                        step: "0.01",
                        onChange: (ev) =>
                          formProps.setFieldValue(
                            ev.target.name,
                            ev.target.value,
                          ),
                        span: (
                          <span
                            style={{
                              position: "absolute",
                              right: "0.5%",
                              top: "10%",
                            }}
                          >
                            €/año
                          </span>
                        ),
                        errors: "",
                      },
                      {
                        name: "ibiShowOnWeb",
                        label: "Mostrar Web",
                        type: "checkbox",
                        checked: formProps.values.ibiShowOnWeb,
                        onChange: (ev) =>
                          formProps.setFieldValue(
                            ev.target.name,
                            !formProps.values.ibiShowOnWeb,
                          ),
                        errors: "",
                      },
                    ]}
                  />
                </div>
                <div className="DetailsAds__container__col--item">
                  <InputsGroup
                    label="Tasa de Basuras"
                    inputs={[
                      {
                        name: "trashFeeValue",
                        label: "",
                        type: "number",
                        placeholder: "Escribe aquí",
                        value: formProps.values.trashFeeValue,
                        step: "0.01",
                        onChange: (ev) =>
                          formProps.setFieldValue(
                            ev.target.name,
                            ev.target.value,
                          ),
                        span: (
                          <span
                            style={{
                              position: "absolute",
                              right: "0.5%",
                              top: "10%",
                            }}
                          >
                            €/año
                          </span>
                        ),
                        errors: "",
                      },
                      {
                        name: "trashFeeShowOnWeb",
                        label: "Mostrar Web",
                        type: "checkbox",
                        checked: formProps.values.trashFeeShowOnWeb,
                        onChange: (ev) =>
                          formProps.setFieldValue(
                            ev.target.name,
                            !formProps.values.trashFeeShowOnWeb,
                          ),
                        errors: "",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </AccordionTab>
          <AccordionTab header="Calidades">
            <div className="DetailsAds__container">
              <div className="DetailsAds__container__col">
                {departmentFields[formProps.values.department]?.map((field) => (
                  <Input
                    key={field.name}
                    label={field.label}
                    type={field.type}
                    name={field.name}
                    value={formProps.values[field.name]}
                    onChange={(ev) =>
                      formProps.setFieldValue(field.name, ev.target.value)
                    }
                  />
                ))}
              </div>
              {/* Calidades --------------- Otros */}

              <div className="DetailsAds__container__col">
                <span>Otros</span>

                <div className="DetailsAds__container__col--item-qualities">
                  {zone === "Patrimonio" && (
                    // CASO PATRIMONIO: Renderizado por Grupos
                    <>
                      {patrimonioGroups.map((group, index) => (
                        <div key={group.title || index}>
                          <h4
                            style={{
                              margin: "2rem 0",
                              color: "#666",
                              fontWeight: "bold",
                              fontSize: "1.1em",
                            }}
                          >
                            {group.title}
                          </h4>
                          {/* AQUI APLICAMOS EL ESTILO GRID */}
                          <div className="DetailsAds__container__col--qualities">
                            {group.fields.map((field) => (
                              <QualityItem
                                key={field.name}
                                field={field}
                                formProps={formProps}
                                icon={qualityIcons[field.name]}
                              />
                            ))}
                          </div>
                          <hr
                            style={{
                              border: "0",
                              borderTop: "1px solid #eee",
                              margin: "10px 0",
                            }}
                          />
                        </div>
                      ))}
                    </>
                  )}
                  {zone === "Residencial" && (
                    // CASO Residencial: Renderizado por Grupos
                    <div style={{ width: "100%" }}>
                      {residentialGroups.map((group, index) => (
                        <div key={group.title || index}>
                          <h4
                            style={{
                              margin: "2rem 0",
                              color: "#666",
                              fontWeight: "bold",
                              fontSize: "1.1em",
                            }}
                          >
                            {group.title}
                          </h4>
                          {/* AQUI APLICAMOS EL ESTILO GRID */}
                          <div className="DetailsAds__container__col--qualities">
                            {group.fields.map((field) => (
                              <QualityItem
                                key={field.name}
                                field={field}
                                formProps={formProps}
                                icon={qualityIcons[field.name]}
                              />
                            ))}
                          </div>
                          <hr
                            style={{
                              border: "0",
                              borderTop: "1px solid #eee",
                              margin: "10px 0",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {zone === "Costa" && (
                    // CASO Costa: Renderizado por Grupos
                    <div style={{ width: "100%" }}>
                      {costaGroups.map((group, index) => (
                        <div key={group.title || index}>
                          <h4
                            style={{
                              margin: "2rem 0",
                              color: "#666",
                              fontWeight: "bold",
                              fontSize: "1.1em",
                            }}
                          >
                            {group.title}
                          </h4>
                          <div className="DetailsAds__container__col--qualities">
                            {group.fields.map((field) => {
                              if (
                                field.name === "outdoorPoolClimatized" &&
                                !formProps.values.outdoorPoolCheck
                              ) {
                                return null;
                              }

                              return (
                                <QualityItem
                                  key={field.name}
                                  field={field}
                                  formProps={formProps}
                                  icon={qualityIcons[field.name]}
                                />
                              );
                            })}
                          </div>
                          <hr
                            style={{
                              border: "0",
                              borderTop: "1px solid #eee",
                              margin: "10px 0",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {zone === "Campos Rústicos & Activos Singulares" && (
                    // CASO Activos Singulares & Campos Rústicos: Renderizado por Grupos
                    <div style={{ width: "100%" }}>
                      {singularesYRusticoGroups.map((group, index) => (
                        <div key={group.title || index}>
                          <h4
                            style={{
                              margin: "2rem 0",
                              color: "#666",
                              fontWeight: "bold",
                              fontSize: "1.1em",
                            }}
                          >
                            {group.title}
                          </h4>
                          {/* AQUI APLICAMOS EL ESTILO GRID */}
                          <div className="DetailsAds__container__col--qualities">
                            {group.fields.map((field) => (
                              <QualityItem
                                key={field.name}
                                field={field}
                                formProps={formProps}
                                icon={qualityIcons[field.name]}
                              />
                            ))}
                          </div>
                          <hr
                            style={{
                              border: "0",
                              borderTop: "1px solid #eee",
                              margin: "10px 0",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </AccordionTab>
          <AccordionTab header="Descripción">
            <div>
              <div>
                <Textarea
                  name="web"
                  label="Descripción web"
                  placeholder="Escribe aquí"
                  value={formProps.values.web}
                  onChange={(ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value)
                  }
                />
              </div>
              <div>
                <Textarea
                  max="600"
                  name="emailPDF"
                  placeholder="Escribe aquí"
                  label="Descripción email / PDF"
                  value={formProps.values.emailPDF}
                  onChange={(ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value)
                  }
                />
              </div>
              <div>
                <Textarea
                  name="distribution"
                  label="Distribución"
                  placeholder="Escribe aquí"
                  value={formProps.values.distribution}
                  onChange={(ev) =>
                    formProps.setFieldValue(ev.target.name, ev.target.value)
                  }
                />
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      )}
    </>
  );
};

export default DetailsAds;
